export default "__VITE_ASSET__BrjfjS1p__"